import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import DataWrapper from '../../principal/containers/DataWrapper';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { TabelaCadastro } from '../components/TabelaCadastro';
import { Validacao } from '../../comum/components/Validacao';
import PisoSalarialStore from '../stores/PisoSalarialStore';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import { createSelectOptions,formatarDataISO8601, formatarValorReal, nullable, ordenarData,
    formatarDataHoraISO8601 } from '../../../utils/formatar';

@inject('store')
@DataWrapper
@observer
export class PisoSalarial extends Component {
  constructor(props) {
    super(props);
    this.modal = this.props.store.modalStore;
    this.appStore = this.props.store.appStore;
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    this.controller = new PisoSalarialStore(this.modal);
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo('Piso Salarial');
    this.controller.carregarLista();
    this.controller.carregarEmpresasGlobo();
    this.controller.carregarSindicatos();    
  }

  modalForm = () => {
    
    const { pisoSelecionado, impactedCount, empresasGlobo, sindicatos } = this.controller;

    const empresasOptions = createSelectOptions(empresasGlobo, "id", "nome");
    const sindicatosOptions = createSelectOptions(sindicatos, "id", "nome");
    const dataVigencia = pisoSelecionado ? pisoSelecionado.momentDataInicioVigencia : null;

    return (
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label>Unidade de negócio (BU) <sup>*</sup></Label>
            <Select
              simpleValue
              options={empresasOptions}
              value={pisoSelecionado.empresaGlobo.id}
              onChange={(value) => this.controller.setEmpresaGloboId(value)}
              isDisabled={pisoSelecionado.id} // Não pode editar empresa de um piso existente
            />
            <Validacao id="empresaGloboId" valor={pisoSelecionado.empresaGlobo.id} tipo={['isRequired']} />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Sindicato <sup>*</sup></Label>
            <Select
              simpleValue
              options={sindicatosOptions}
              value={pisoSelecionado.sindicato.id}
              onChange={(value) => this.controller.setSindicatoId(value)}
              isDisabled={pisoSelecionado.id} // Não pode editar sindicato de um piso existente
            />
            <Validacao id="sindicatoId" valor={pisoSelecionado.sindicato.id} tipo={['isRequired']} />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>A partir de <sup>*</sup></Label>
            <Input
              type="text"
              value={dataVigencia ? dataVigencia.format('DD/MM/YYYY') : ''}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Piso salarial <sup>*</sup></Label>
            <NumberFormat
              className="form-control"
              prefix="R$ "
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              value={pisoSelecionado.valor}
              onChange={(event, values) => this.controller.setValor(values.floatValue)}
            />
            <Validacao id="valor" valor={pisoSelecionado.valor} tipo={['isRequired']} />
          </FormGroup>
        </Col>
        {impactedCount > 0 &&
          <Col xs={12}>
            <div className="alert alert-info">
              <strong>{impactedCount}</strong> contrato(s) será(ão) reajustado(s) com esta alteração.
            </div>
          </Col>
        }
          <Col xs={12} md={12} lg={12}>
              <FormGroup check >
                  <Label check>
                      <Input type="checkbox" checked={pisoSelecionado.aplicarReajuste} onChange={() => this.controller.toggleAplicarReajuste()} />{' '}
                      <Label>Aplicar reajuste nos contratos e solicitações em andamento</Label>
                  </Label>
              </FormGroup>
          </Col>
      </Row>
    );
  };

  empresaGloboFormat(cell) {
      if(cell) {
          return cell && cell.nome ? cell.nome : "";
      }
  }
  sindicatoFormat(cell) {
      if(cell) {
          return cell && cell.nome ? cell.nome : "";
      }
  }

  obterTituloMobile = (objeto) => {
    return `${objeto.sindicatoNome || 'Sindicato'} - ${objeto.empresaGloboNome || 'Empresa'}`;
  };

  obterConteudoMobile = (objeto) => {
    return (
      <div>
        Valor: <NumberFormat value={objeto.valor} displayType={'text'} thousandSeparator="." decimalSeparator="," prefix={'R$ '} decimalScale={2} fixedDecimalScale={true} /><br />
        Vigência: {new Date(objeto.dataInicioVigencia).toLocaleDateString()}
      </div>
    );
  };

  render() {
    const colunas = [
      { field: 'empresaGlobo', 
        dataFormat: this.empresaGloboFormat,
        label: 'Unidade de negócio (BU)' },
      { field: 'sindicato', 
        dataFormat: this.sindicatoFormat,
        label: 'Sindicato' },
      {
        field: 'valor',
        label: 'Piso Salarial',
        dataFormat: formatarValorReal,
      },
      {
        field: 'dataInicioVigencia',
        label: 'A partir de',
        dataFormat: formatarDataISO8601,
      },
      {
        field: 'quantidadeContratosImpactados',
        label: 'Abaixo do piso'
      },
    ];

    return (
      <div>
        <div className="form-wrapper">
          <div className={this.appStore.width > 768 ? 'content-panel panel-sm' : 'panel-sm'}>
            <TabelaCadastro
              nomeCadastro={'Piso Salarial'}
              listaItens={this.controller.pisosList}
              onChange={(value) => this.controller.setLista(value)}
              colunas={colunas}
              temBusca={true}
              criarNovos={true}
              modalCadastrar={this.modalForm()}
              modalEditar={this.modalForm()}
              preencherModal={(row) => this.controller.preencherModal(row)}
              cadastrar={() => this.controller.cadastrar()}
              editar={() => this.controller.editar()}
              remover={() => this.controller.remover()}
              tituloMobile={this.obterTituloMobile}
              conteudoMobile={this.obterConteudoMobile}
              loading={this.controller.loading}
            />
          </div>
        </div>
      </div>
    );
  }
}
